export default __webpack_public_path__ + "static/media/Inconsolata-Bold.104ed088.woff";